// @ts-nocheck: converted from JS

import ForgotPassword from '@/components/PasswordForget';

export default ForgotPassword;
